import React from "react";
import { FallbackImage } from "../../constants/AppConstants";
import { useHistory } from "react-router-dom";

const MiniArticle = ({ title, imageUrl, slug }) => {
  const history = useHistory();
  return (
    <div
      onClick={() => history.push("/viewpost/" + slug)}
      className="mb-4 mini-article-container cursor-pointer"
    >
      <div className="flex align-start" style={{ alignItems: "start" }}>
        <div
          className="mini-thumb"
          style={{ backgroundImage: `url(${imageUrl || FallbackImage})` }}
        />
        <p className="title">
          {title.length > 40 ? `${title.substr(0, 40)}...` : title}
        </p>
      </div>
      <style jsx="true">
        {`
          .mini-article-container {
            width: 100%;
          }
          .mini-thumb {
            box-sizing: border-box;
            height: 64px;
            min-width: 96px !important;
            max-width: 96px !important;
            background-size: cover;
            background-position: center;
            border: 1px solid #979797;
            border-radius: 8px;
            margin-right: 15px;
          }
          p.title {
            color: #333333;
            font-family: Lato;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
            margin-bottom: 3px;
            width: 200px;
          }
        `}
      </style>
    </div>
  );
};

export default MiniArticle;
